// @ts-nocheck
import Styleguide from "@toolkit/Framework/Types/Styleguide";

const zIndex: Styleguide["zIndex"] = {
    stickyHeader: 1289,
};

export default zIndex;
